var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "22",
        viewBox: "0 0 14 22",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.89832 10.9997C7.86801 10.9997 8.79799 10.6145 9.48368 9.9288C10.1694 9.24312 10.5546 8.31314 10.5546 7.34344C10.5546 6.37375 10.1694 5.44377 9.48368 4.75809C8.79799 4.07241 7.86801 3.68719 6.89832 3.68719C5.92862 3.68719 4.99864 4.07241 4.31296 4.75809C3.62728 5.44377 3.24207 6.37375 3.24207 7.34344C3.24207 8.31314 3.62728 9.24312 4.31296 9.9288C4.99864 10.6145 5.92862 10.9997 6.89832 10.9997ZM5.59292 12.3708C2.77932 12.3708 0.499878 14.6502 0.499878 17.4638C0.499878 17.9323 0.879785 18.3122 1.34824 18.3122H12.4484C12.9168 18.3122 13.2968 17.9323 13.2968 17.4638C13.2968 14.6502 11.0173 12.3708 8.20371 12.3708H5.59292Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }